/**
 * style-picker — 砌風格 prompt（**純函數**；Node 可 import → 真單元測試）
 *   ⚠️ 顯示文字（label）同入 provider 嘅文字（prompt）**分開**（例：中文顯示／英文入 prompt）
 */
export interface StyleOption {
  id: string;
  label: string;
  prompt: string;
}

export function buildStylePrompt(selectedIds: string[], options: StyleOption[], freeText = ""): string {
  const picked = options.filter((o) => selectedIds.includes(o.id)).map((o) => o.prompt.trim());
  const free = freeText.trim();
  return [...picked, free].filter(Boolean).join(", ");
}
